import { Box } from "@mui/material";
import { useState } from "react";
import OutlinedButton from "../../../../components/buttons/OutlinedButton";
import CustomToolTip from "../../../../components/CustomTooltip";
import { icons } from "../icons/iconExport";
import TagsDropdown from "./TagsDropDown/TagsDropdown";

export default function EditTagsButton({
  checkedEntities,
  showLabel = true,
  disabled = false,
}) {
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);

  return (
    <Box>
      <CustomToolTip title={!showLabel ? "Add a tag" : ""} placement="top">
        <OutlinedButton
          onClick={(event) => {
            setMenuAnchorEl(event.currentTarget);
          }}
          icon={icons.TagIcon}
          size="small"
          buttonStyle="outlined"
          color="inherit"
          disabled={checkedEntities.length === 0 || disabled}
        >
          {showLabel ? "Tags" : ""}
        </OutlinedButton>
      </CustomToolTip>
      {menuAnchorEl && (
        <TagsDropdown
          selectedEntities={checkedEntities}
          menuAnchorEl={menuAnchorEl}
          setMenuAnchorEl={setMenuAnchorEl}
        />
      )}
    </Box>
  );
}
